import AdminCommunicationApi, {
  IFetchCommunicationsParams
} from "../api/adminCommunicationApi";
import * as types from "./actionTypes";
import { beginAjaxCall } from "./ajaxStatusActions";

export function fetchCommunications(params: IFetchCommunicationsParams = {}) {
  return async (dispatch: any) => {
    dispatch(beginAjaxCall());
    dispatch({ type: types.ADMIN_COMMUNICATIONS_FETCH_STARTED });

    try {
      const data = await AdminCommunicationApi.fetchCommunications(params);
      dispatch({
        type: types.ADMIN_COMMUNICATIONS_FETCH_FULFILLED,
        payload: data,
      });
      return data;
    } catch (error: any) {
      dispatch({
        type: types.ADMIN_COMMUNICATIONS_FETCH_REJECTED,
        payload: error.message,
      });
      throw error;
    }
  };
}

export function selectCommunication(communicationId: string | null) {
  return {
    type: types.ADMIN_COMMUNICATIONS_SELECT,
    payload: communicationId,
  };
}

export function setFilters(filters: ICommunicationFilters) {
  return {
    type: types.ADMIN_COMMUNICATIONS_SET_FILTERS,
    payload: filters,
  };
}

export function clearFilters() {
  return {
    type: types.ADMIN_COMMUNICATIONS_CLEAR_FILTERS,
  };
}
